import styled from 'styled-components';
import {tokens} from "../../../theme";

export const PanelContainer = styled.div<{ $isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.palette.background.paper};
    border-radius: ${tokens.radius['2xl']};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    padding: 16px 24px 0 24px;
    width: 100%;
    min-height: 700px;
    overflow: hidden;
    transition: transform 300ms ease, opacity 300ms ease;
    margin: 16px 0;

    @media (min-width: 1600px) {
        transform: translateX(${props => props.$isOpen ? '0' : '100%'});
        opacity: ${props => props.$isOpen ? '1' : '0'};
    }
`;

export const PanelHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
`;



export const SectionDivider = styled.div`
    height: 1px;
    background-color: ${({theme}) => theme.palette.dividers.subtle};
    margin: 16px 0;
`;



export const ScrollableContent = styled.div<{ $isEmpty?: boolean }>`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    display: flex;
    flex-direction: ${props => props.$isEmpty ? 'row' : 'column'};
    align-items: ${props => props.$isEmpty ? 'center' : 'stretch'};
    justify-content: ${props => props.$isEmpty ? 'center' : 'flex-start'};

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px;

        &:hover {
            background: rgba(0, 0, 0, 0.3);
        }
    }
`;

export const EmptyState = styled.div`
    margin-bottom: 30px;
    padding: 16px;
    text-align: center;
    color: ${({theme}) => theme.palette.text.hint};
`;

export const EmptyStateText = styled.p`
    font-size: ${tokens.fontSize.sm};
    margin: 0;
`;